import React, { useMemo, useState } from 'react';
import CardTable from '../CardTable';
import styles from '../card.module.css';

/* Вкладка «Дисциплины» (п. 8 ТЗ).
   Отдаются и действующие, и закрытые дисциплины; переключатель «Вкл. архивные»
   (включён по умолчанию) — фильтр отображения, данные он не меняет. Индекс и
   «Дисциплина РПД» у части строк пусты — прочерк; повторы не схлопываются. */

const COLUMNS = [
  { key: 'index', title: 'Индекс', cell: row => row.index, className: styles.mono },
  { key: 'course', title: 'Дисциплина РПД', cell: row => row.course, className: styles.lead },
  { key: 'discipline', title: 'Дисциплина', cell: row => row.discipline, className: styles.lead },
  { key: 'status', title: 'Статус', cell: row => row.status },
];

const Disciplines = ({ data }) => {
  const [withArchived, setWithArchived] = useState(true);

  const rows = useMemo(
    () => (withArchived
      ? data.items
      : data.items.filter(item => item.status !== 'закрыт')),
    [data.items, withArchived]
  );

  return (
    <div className={styles.pane}>
      <label className={styles.toggleRow}>
        <input
          type="checkbox"
          checked={withArchived}
          onChange={e => setWithArchived(e.target.checked)}
        />
        Вкл. архивные
      </label>

      <CardTable
        columns={COLUMNS}
        rows={rows}
        nowrap
        rowKey={(row, index) => (row.cid != null ? `${row.cid}-${index}` : index)}
        counter={<>Всего записей: <b>{rows.length}</b></>}
        emptyTitle="Дисциплин нет"
        emptyText="За кафедрой не закреплено ни одной дисциплины"
      />
    </div>
  );
};

export default Disciplines;
